export const settingsRoutes = [
  { name: "Main Activity", path: "main-activity", check: "Main Activity" },
  { name: "Quotes", path: "orders", check: "Orders" },
  { name: "Users", path: "users", check: "User" },
  { name: "Roles", path: "roles", check: "Roles" },
  // { name: "Rights", path: "rights", check: "Rights" },
  { name: "Profile", path: "profile", check: "Profile" },
  { name: "Archives", path: "archives", check: "Archives" },
  { name: "Limits", path: "limits", check: "Limits" },
  { name: "Synchronize", path: "synchronize", check: "Synchronize" },
  { name: "Restricted Designs", path: "restricted-designs", check: "Restricted Designs", replace: "Restricted Category" },
  { name: "Missing Images", path: "missing-images", check: "Missing Images" },
  { name: "Design Import", path: "design-import", check: "Design Import" },
  { name: "Rate Master Rights", path: "rate-master-rights", check: "Rate Master Rights" },
  { name: "Waba Rights", path: "waba-rights", check: "Waba Rights" },
  { name: "Labour Rights", path: "labour-rights", check: "Labour Rights" },
  { name: "Design Update", path: "design-update", check: "Design Update" },
  { name: "Update Images", path: "update-images", check: "Update Images" },
  // Restricted Designs
  // { name: "Missing Images", path: "missing-images", check: "Missing Images" },
  { name: "Melting Requests", path: "melting-requests", check: "Melting Requests" },
  { name: "Product USP & Gallery", path: "product-usp-and-gallery", check: "Product USP & Gallery" },
  { name: "My Binny’s Access", path: "my-binnys-access", check: "My Binny’s Access" },
  { name: "Stock Tray", path: "stock-tray", check: "Stock Tray" },
  { name: "Event Type", path: "event-type", check: "Event Type" },
  { name: "Service Request", path: "service-request", check: "Service Request" },
  { name: "New Rights", path: "new-rights", check: "New Rights" }
].sort((a, b) => a.name.localeCompare(b.name));


const getCurrentFinancialYear = () => {
  const now = new Date();
  return now.getMonth() >= 3 ? now.getFullYear() : now.getFullYear() - 1;
};

const getLedgerFYOptions = (params) => {
  const currentFY = getCurrentFinancialYear();
  return Array.from({ length: 2 }, (_, i) => {
    const year = currentFY - i;
    const label = `Ledger FY ${String(year).slice(2)}-${String(year + 1).slice(2)}`;
    return {
      label,
      path: `/client-flow/${params?.clientId}/dues-ledger/Ledger`,
      state: { ledger: true, financialYear: year },
    };
  });
};

export const getClientBreadcrumbOptions = (params, dynamicList = {}) => {
  const show = (key) => dynamicList[key] > 0;
  return {
    Dues: {
      isDropdown: true,
      options: [
        {
          label: "Dues",
          path: `/client-flow/${params?.clientId}/dues-ledger/Dues`,
          state: { allDues: false },
        },
        {
          label: "All Dues",
          path: `/client-flow/${params?.clientId}/dues-ledger/Dues`,
          state: { allDues: true },
        },
      ],
    },
    Ledger: {
      isDropdown: true,
      options: getLedgerFYOptions(params),
    },
    Quotes: {
      isDropdown: true,
      options: [
        {
          label: "All Quotes",
          path: `/client-flow/${params?.clientId}/quotes-orders/All-quotes`,
          state: { Quotes: "All Quotes" },
        },
        {
          label: "Pending Quotes",
          path: `/client-flow/${params?.clientId}/quotes-orders/Pending-quotes`,
          state: { Quotes: "Pending Quotes" },
        },
        {
          label: "Completed Quotes",
          path: `/client-flow/${params?.clientId}/quotes-orders/Completed-quotes`,
          state: { Quotes: "Completed Quotes" },
        },
        {
          label: "Cancelled Quotes",
          path: `/client-flow/${params?.clientId}/quotes-orders/Cancelled-quotes`,
          state: { Quotes: "Cancelled Quotes" },
        },
      ],
    },
    Orders: {
      isDropdown: true,
      options: [
        // show("allOrders") && {
        //   label: "All Orders",
        //   path: `/client-flow/${params.clientId}/quotes-orders/All-orders`,
        //   state: { Orders: "All Orders" },
        // },
        // show("pendingOrders") && {
        //   label: "Pending Orders",
        //   path: `/client-flow/${params.clientId}/quotes-orders/Pending-orders`,
        //   state: { Orders: "Pending Orders" },
        // },
        // show("wipOrders") && {
        //   label: "WIP Orders",
        //   path: `/client-flow/${params.clientId}/quotes-orders/WIP-orders`,
        //   state: { Orders: "WIP Orders" },
        // },
        // show("completedOrders") && {
        //   label: "Completed Orders",
        //   path: `/client-flow/${params.clientId}/quotes-orders/Completed-orders`,
        //   state: { Orders: "Completed Orders" },
        // },
        // show("cancelledOrders") && {
        //   label: "Cancelled Orders",
        //   path: `/client-flow/${params.clientId}/quotes-orders/Cancelled-orders`,
        //   state: { Orders: "Cancelled Orders" },
        // },

        {
          label: "All Orders",
          path: `/client-flow/${params?.clientId}/quotes-orders/All-orders`,
          state: { Orders: "All Orders" },
        },
        {
          label: "Pending Orders",
          path: `/client-flow/${params?.clientId}/quotes-orders/Pending-orders`,
          state: { Orders: "Pending Orders" },
        },
        {
          label: "WIP Orders",
          path: `/client-flow/${params?.clientId}/quotes-orders/WIP-orders`,
          state: { Orders: "WIP Orders" },
        },
        {
          label: "Completed Orders",
          path: `/client-flow/${params?.clientId}/quotes-orders/Completed-orders`,
          state: { Orders: "Completed Orders" },
        },
        {
          label: "Cancelled Orders",
          path: `/client-flow/${params?.clientId}/quotes-orders/Cancelled-orders`,
          state: { Orders: "Cancelled Orders" },
        },
      ].filter(Boolean),
    },
    Wip: {
      isDropdown: true,
      options: [
        {
          label: "Pending",
          path: `/client-flow/${params?.clientId}/wip/Pending`,
          state: { Wip: "Pending" },
        },
        {
          label: "Pre Production",
          path: `/client-flow/${params?.clientId}/wip/Pre-Production`,
          state: { Wip: "Pre Production" },
        },
        {
          label: "Production",
          path: `/client-flow/${params?.clientId}/wip/Production`,
          state: { Wip: "Production" },
        },
        {
          label: "Post Production",
          path: `/client-flow/${params?.clientId}/wip/Post-Production`,
          state: { Wip: "Post Production" },
        },
        {
          label: "Other",
          path: `/client-flow/${params?.clientId}/wip/Other`,
          state: { Wip: "Other" },
        },
      ],
    },
  };
};
